export default "__VITE_ASSET__42db1cd5__"